import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/_guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: ThemeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'index',
        loadChildren:
          './pages/loader-enabled-enabled-type-spinner-message/index/index.module#IndexModule'
      },
      {
        path: 'inner',
        loadChildren: './pages/default/inner/inner.module#InnerModule'
      },
      {
        path: 'csr',
        loadChildren: './pages/csr/csr.module#CsrModule'
      },
      {
        path: 'electricity-plan-parser',
        loadChildren:
          './pages/electricity-planparser/electricity-planparser.module#BillParserModule'
      },
      {
        path: 'negotiator',
        loadChildren: './pages/negotiator/negotiator.module#NegotiatorModule'
      },
      {
        path: 'pdf-parser',
        loadChildren: './pages/pdf-parser/pdf-parser.module#PdfParserModule'
      },
      {
        path: 'profile',
        loadChildren: './pages/default/profile/profile.module#ProfileModule'
      },
      {
        path: 'clickup/:cust_id',
        loadChildren: './pages/clickup-webhook/clickup-webhook.module#ClickupWebhookModule'
      },
      {
        path: '404',
        loadChildren: './pages/default/not-found/not-found.module#NotFoundModule'
      },
      {
        path: 'providers',
        loadChildren: './pages/providers/provider.module#ProviderModule'
      },
      {
        path: 'reports',
        loadChildren: './pages/reports/report.module#ReportModule'
      },
      {
        path: 'plans',
        loadChildren: './pages/plans/plan.module#PlanModule'
      },
      {
        path: 'plans/create/:plan_type',
        loadChildren: './pages/plans/plan.module#PlanModule'
      },
      {
        path: 'plans/:plan_type/:plan_id',
        loadChildren: './pages/plans/plan.module#PlanModule'
      },
      {
        path: 'test/parser',
        loadChildren: './pages/test/parser/parser.module#ParserModule'
      },
      {
        path: 'test/electricity',
        loadChildren: './pages/test/electricity/electricity.module#ElectricityTestModule'
      },
      {
        path: '',
        children: [
          {
            path: 'portal',
            loadChildren: './../portalV2/main.module#MainModule'
          }
        ]
      },
      {
        path: '**',
        redirectTo: 'portal'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ThemeRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/theme/theme-routing.module.ts